/**
 * rem 设置手机端响应式根类字体大小
 */
export function initRem() {
  const setRootFontSize = () => {
    const doc = document.documentElement;
    const width = doc.clientWidth;
    const fontSize = Math.min(Math.max((width / 375) * 10, 8), 20);
    doc.style.fontSize = `${fontSize}px`;
  };
  
  setRootFontSize();
  window.addEventListener('resize', setRootFontSize);
  window.addEventListener('orientationchange', setRootFontSize);
}